export default function EditorialTransition() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32 lg:py-40">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/31b112e8-893a-4387-911f-a71471a706e7_compressed_7e57fc68-1aba-471f-a7a5-7428c023125b.webp"
          alt="Dos mujeres profesionales revisando estrategia en pizarra de oficina moderna"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/35 to-foreground-950/50"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 text-center reveal-on-scroll">
        <span className="block w-10 h-px bg-accent-300/70 mx-auto mb-8"></span>
        <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-light text-background-50 leading-[1.15] max-w-[720px] mx-auto">
          Claridad para decidir.
          <br />
          Confianza para avanzar.
        </p>
      </div>
    </section>
  );
}